export class Project {
  constructor(
    public id: string,
    public name: string,
    public sourceLanguageCode: string,
    public createdAt: string,
    public deletedAt: string | null = null
  ) {}

  static fromRow(row: Record<string, any>): Project {
    return new Project(row.id, row.name, row.source_language_code, row.created_at, row.deleted_at ?? null);
  }
}

export default Project;
